import React from 'react';
import DefaultImg from '@/pages/opinion/assets/imgs/influencer-user-avatar.png';
import RenderImg from '../../RenderImg';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { dealwithBiLiBiLiImage } from '@/pages/opinion/utils/cdnUrl';
import { Bubble } from 'tea-component';

export default function UserInfoItem({
  icon,
  defaultImage,
  name,
  children,
  isLink = true,
  onClick,
  iconClick,
  shareUrl,
  shareUrlElement = (
    <span className="dbo-common-userinfo-share">
      <SvgIcon type="aigc-jump" />
    </span>
  ),
  loading = false,
  showBubble = false,
  onlyOneLine = false,
}: {
  icon: string;
  defaultImage?: string;
  name: string;
  loading?: boolean;
  children?: (className: string, classNamePrefix: string) => any;
  isLink?: boolean;
  shareUrl?: String;
  onClick?: () => void;
  iconClick?: (value: any) => void;
  showBubble?: boolean;
  onlyOneLine?: boolean;
  shareUrlElement?: JSX.Element;
}) {
  let curIcon = dealwithBiLiBiLiImage(icon);

  return (
    <div
      className={`dbo-common-userinfo  ${isLink ? '--active' : ''}`}
      onClick={(e) => {
        onClick?.();
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <RenderImg
        onClick={iconClick}
        coverImage={curIcon}
        defaultImage={defaultImage || DefaultImg}
        className="dbo-common-userinfo-useravatar"
      ></RenderImg>
      <div className="dbo-common-userinfo-userinfo">
        <div className="dbo-common-userinfo-title">
          <Bubble dark closeOnScroll content={showBubble ? name : null}>
            <div className={`dbo-common-userinfo-username`}>{name}</div>
          </Bubble>
          {shareUrl && shareUrlElement}
        </div>
        {children?.('dbo-common-userinfo-subinfo', 'dbo-common-userinfo')}
      </div>
    </div>
  );
}
